import HolidayHome from "@/Component/Module/HolidayHome";
import SeoHead from "@/Component/Seo/SeoHead";
import {
  serverFetchCouponList,
  serverFetchFeaturedJourneys,
  serverFetchHolidayHomePageAdvertisement,
  serverFetchHolidayHomePageHeading,
  serverFetchHolidaysBreaks,
  serverFetchReviewsList,
  serverFetchSeasonalDeals,
  serverFetchUnlockParadise,
} from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import {
  normalizeHomePageAdvertisement,
  normalizeHomePageHeading,
} from "@/utils/homePageHelpers";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function Home({
  seo,
  seoCountry,
  initialFeaturedJourney,
  initialUnlockParadise,
  initialCouponList,
  initialSeasonalDeals,
  initialHolidaysBreaks,
  initialReviewsList,
  initialHomePageHeading,
  initialHomePageAdvertisement,
}) {
  return (
    <>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Next Holidays | Your Next Journey Begins Here"
      />
      <HolidayHome
        data={{
          initialFeaturedJourney,
          initialUnlockParadise,
          initialCouponList,
          initialSeasonalDeals,
          initialHolidaysBreaks,
          initialReviewsList,
          initialHomePageHeading,
          initialHomePageAdvertisement,
        }}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context, { ignoreRedirect: true });
  if (seoResult.redirect) return seoResult;

  try {
    const [
      featuredJourneys,
      unlockParadise,
      couponList,
      seasonalDeals,
      visaFreeBreaks,
      visaOnArrivalBreaks,
      eVisaBreaks,
      reviewsList,
      homePageHeading,
      homePageAdvertisement,
    ] = await Promise.all([
      serverFetchFeaturedJourneys(country),
      serverFetchUnlockParadise(country),
      serverFetchCouponList(country),
      serverFetchSeasonalDeals(country),
      serverFetchHolidaysBreaks(1, country),
      serverFetchHolidaysBreaks(2, country),
      serverFetchHolidaysBreaks(3, country),
      serverFetchReviewsList({ moduleType: "Holiday" }, country),
      serverFetchHolidayHomePageHeading(country),
      serverFetchHolidayHomePageAdvertisement(country).catch(() => null),
    ]);

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialFeaturedJourney: featuredJourneys?.data || null,
        initialUnlockParadise: unlockParadise?.data || null,
        initialCouponList: couponList?.data || null,
        initialSeasonalDeals: Array.isArray(seasonalDeals?.data)
          ? seasonalDeals.data
          : [],
        initialHolidaysBreaks: {
          1: Array.isArray(visaFreeBreaks?.data) ? visaFreeBreaks.data : [],
          2: Array.isArray(visaOnArrivalBreaks?.data) ? visaOnArrivalBreaks.data : [],
          3: Array.isArray(eVisaBreaks?.data) ? eVisaBreaks.data : [],
        },
        initialReviewsList: reviewsList?.data || null,
        initialHomePageHeading: normalizeHomePageHeading(homePageHeading),
        initialHomePageAdvertisement:
          normalizeHomePageAdvertisement(homePageAdvertisement),
      },
    };
  } catch {
    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialFeaturedJourney: null,
        initialUnlockParadise: null,
        initialCouponList: null,
        initialSeasonalDeals: [],
        initialHolidaysBreaks: { 1: [], 2: [], 3: [] },
        initialReviewsList: null,
        initialHomePageHeading: null,
        initialHomePageAdvertisement: null,
      },
    };
  }
}
